import {galleryService} from '../services/gallery.services';

export const galleryData = (data ) => dispatch => {

    let galleryList = galleryService.getAllGallery(data);

    galleryList.then(galleryList => {
        dispatch({
            type: "GALLERY_DATA_SUCCESS",
            galleryList
        });
    });
}

export const galleryDataFromStore = (state ) => dispatch => {

    dispatch({
        type:"GALLERY_DATA_FROM_STORE",
        state
    });

}

export const setType = ( gal_type ) => dispatch => {
    dispatch({
        type: "SET_TYPE",
        gal_type
    });
}

export const getType = (state) => dispatch => {
    dispatch({
        type: "GET_TYPE",
        state
    });
}

export const setItemId = ( gal_item ) => dispatch => {
    dispatch({
        type: "SET_ITEM_ID",
        gal_item
    });
}

export const getItemId = ( state ) => dispatch => {
    dispatch({
        type: "GET_ITEM_ID",
        state
    });
}

export const searchGallery = (data ) => dispatch => {

    /*dispatch({
        type:"FETCH_GALLERY_DATA",
        data
    });*/

    let galleryList = galleryService.getAllGallery(data);

    galleryList.then(galleryList => {
        dispatch({
            type: "GALLERY_DATA_SUCCESS",
            galleryList
        });
    });
}

export const downloadFile = ( file ) => dispatch => {

    var downloaded = galleryService.downloadFile(file);

console.log(downloaded);
    dispatch({
        type: "DOWNLOAD_FILE",
        downloaded
    });
}
export const createGallery = (data ) => dispatch => {

    let created = galleryService.saveGallery(data);

    created.then(created => {
        dispatch({
            type: "SAVE_GALLERY",
            created
        });
    });
}



// WEBPACK FOOTER //
// ./src/actions/gallery.js